import React from 'react';


const Container = ({className, children}) => {
  return ( 
    <div className={`container mx-auto py-4 lg:py-8 px-4 lg:px-8 ${className !== undefined ? className : ''}`}>{children}</div>
   );
}
 
export default Container;